import { Navigate } from 'react-router-dom';

import { Permissions } from '@/security';
import { lazyImport } from '@/utils';

// auth
const { Login } = lazyImport(() => import('@/features/auth'), 'Login');
const { Signup } = lazyImport(() => import('@/features/auth'), 'Signup');
const { ForgotPassword } = lazyImport(() => import('@/features/auth'), 'ForgotPassword');
const { PasswordReset } = lazyImport(() => import('@/features/auth'), 'PasswordReset');
const { Tenant } = lazyImport(() => import('@/features/auth'), 'Tenant');
const { VerifyEmail } = lazyImport(() => import('@/features/auth'), 'VerifyEmail');
const { EmailUnverified } = lazyImport(() => import('@/features/auth'), 'EmailUnverified');
const { Inviation } = lazyImport(() => import('@/features/auth'), 'Inviation');

// dashboard
const { Dashboard } = lazyImport(() => import('@/features/dashboard'), 'Dashboard');
const { Customers } = lazyImport(() => import('@/features/dashboard'), 'Customers');

const { Items } = lazyImport(() => import('@/features/item_library'), 'Items');

// settings
const { Api } = lazyImport(() => import('@/features/settings'), 'Api');
const { Billing } = lazyImport(() => import('@/features/settings'), 'Billing');
const { Integrations } = lazyImport(() => import('@/features/settings'), 'Integrations');
const { MyDetails } = lazyImport(() => import('@/features/settings'), 'MyDetails');
const { Notifications } = lazyImport(() => import('@/features/settings'), 'Notifications');
const { Password } = lazyImport(() => import('@/features/settings'), 'Password');
const { Plan } = lazyImport(() => import('@/features/settings'), 'Plan');
const { Profile } = lazyImport(() => import('@/features/settings'), 'Profile');
const { Team } = lazyImport(() => import('@/features/settings'), 'Team');
const { Bookshelves } = lazyImport(() => import('@/features/settings'), 'Bookshelves');

//Projects
const { ListProjects } = lazyImport(() => import('@/features/projects'), 'ListProjects');

// Order
const { Orders } = lazyImport(() => import('@/features/orders'), 'Orders');

// Quoting
const { Quoting } = lazyImport(() => import('@/features/quoting'), 'Quoting');

// Suppliers
const { Suppliers } = lazyImport(() => import('@/features/suppliers'), 'Suppliers');

// Messages
const { Messages } = lazyImport(() => import('@/features/messages'), 'Messages');

// Error pages
const { Error404Page } = lazyImport(() => import('@/components'), 'Error404Page');
const { Error403Page } = lazyImport(() => import('@/components'), 'Error403Page');

const privateRoutes = [
    {
        path: '/dashboard',
        element: <Dashboard />,
        permissionRequired: null
    },
    {
        path: '/projects',
        element: <ListProjects />,
        permissionRequired: null
    },
    {
        path: '/customers',
        element: <Customers />,
        permissionRequired: null
    },
    {
        path: '/settings',
        element: <MyDetails />,
        permissionRequired: null
    },
    {
        path: '/settings/api',
        element: <Api />,
        permissionRequired: null
    },
    {
        path: '/settings/billing',
        element: <Billing />,
        permissionRequired: null
    },
    {
        path: '/settings/integrations',
        element: <Integrations />,
        permissionRequired: null
    },
    {
        path: '/settings/Notifications',
        element: <Notifications />,
        permissionRequired: null
    },
    {
        path: '/settings/password',
        element: <Password />,
        permissionRequired: null
    },
    {
        path: '/settings/plan',
        element: <Plan />,
        permissionRequired: null
    },
    {
        path: '/settings/profile',
        element: <Profile />,
        permissionRequired: null
    },
    {
        path: '/settings/team',
        element: <Team />,
        permissionRequired: Permissions.userRead
    },
    {
        path: '/settings/bookshelves',
        element: <Bookshelves />,
        permissionRequired: null
    },
    {
        path: '/orders',
        element: <Orders />,
        permissionRequired: null
    },
    {
        path: '/quoting',
        element: <Quoting />,
        permissionRequired: null
    },
    {
        path: '/suppliers',
        element: <Suppliers />,
        permissionRequired: null
    },
    {
        path: '/item-library',
        element: <Items />,
        permissionRequired: null
    },
    {
        path: '/messages',
        element: <Messages />,
        permissionRequired: null
    }
].filter(Boolean);

const publicRoutes = [
    {
        path: '/auth/login',
        element: <Login />
    },
    {
        path: '/auth/signup',
        element: <Signup />
    },
    {
        path: '/auth/forgot-password',
        element: <ForgotPassword />
    }
].filter(Boolean);

const emptyTenantRoutes = [
    {
        path: '/auth/tenant',
        element: <Tenant />
    }
].filter(Boolean);

const emailUnverifiedRoutes = [
    {
        path: '/auth/email-unverified',
        element: <EmailUnverified />
    }
].filter(Boolean);

const simpleRoutes = [
    {
        path: '/auth/verify-email',
        element: <VerifyEmail />
    },
    {
        path: '/auth/password-reset',
        element: <PasswordReset />
    },
    {
        path: '/auth/invitation',
        element: <Inviation />
    },
    {
        path: '/403',
        element: <Error403Page />
    },
    {
        path: '',
        element: <Navigate to="/dashboard" />
    },
    {
        path: '*',
        element: <Error404Page />
    }
].filter(Boolean);

export const routes = {
    privateRoutes,
    publicRoutes,
    emptyTenantRoutes,
    emailUnverifiedRoutes,
    simpleRoutes
};
